import * as importedFormats from '@fds/wm-shared-formats';
import { ConsoleLogger } from '@fds/wm-typescript-logger';
import * as moment from 'moment';
import { isAliasFormat, isExtendsDateFormat } from './util/guards';
var DateFormatter = /** @class */ (function () {
    function DateFormatter(locale) {
        this.formats = {};
        this.fallbackFormats = {};
        this.logger = ConsoleLogger.getLogger(DateFormatter.LOGGER_NAME);
        this.setLocale(locale);
        this.importFormats(importedFormats.date.formats);
        this.importFallbackFormats(importedFormats.date.fallback);
    }
    DateFormatter.prototype.setLocale = function (locale) {
        this.locale = locale;
    };
    DateFormatter.prototype.setFormat = function (locale, formatCode, formatDefinition) {
        if (!(locale in this.formats)) {
            this.formats[locale] = {
                formats: {},
            };
        }
        this.formats[locale].formats[formatCode] = formatDefinition;
    };
    DateFormatter.prototype.importFormats = function (formats) {
        var _this = this;
        Object.keys(formats).forEach(function (locale) {
            Object.keys(formats[locale].formats).forEach(function (code) {
                var definition = formats[locale].formats[code];
                _this.setFormat(locale, code, definition);
            });
        });
    };
    DateFormatter.prototype.importFallbackFormats = function (formats) {
        this.fallbackFormats = formats;
    };
    DateFormatter.prototype.format = function (value, formatCode, locale) {
        var formatLocale = locale || this.locale;
        var formatDefinition = this.getFormat(formatCode, formatLocale);
        var momentInstance = DateFormatter.isUnixTimestamp(value) ? moment.unix(value) : moment(value);
        momentInstance.locale(formatLocale);
        return momentInstance.format(formatDefinition.format);
    };
    DateFormatter.setProjectFormats = function (formats) {
        DateFormatter.projectFormats = formats;
    };
    DateFormatter.setProjectFallbackFormats = function (formats) {
        DateFormatter.projectFallbackFormats = formats;
    };
    DateFormatter.prototype.getFormat = function (formatCode, locale) {
        var formatLocale = locale || this.locale;
        var projectFormats = DateFormatter.projectFormats[formatLocale];
        var formats = this.formats[formatLocale];
        var format = null;
        if (DateFormatter.containsFormatCode(projectFormats, formatCode)) {
            format = projectFormats.formats[formatCode];
        }
        else if (DateFormatter.containsFormatCode(formats, formatCode)) {
            format = formats.formats[formatCode];
        }
        else if (DateFormatter.containsFormatCode(DateFormatter.projectFallbackFormats, formatCode)) {
            format = DateFormatter.projectFallbackFormats.formats[formatCode];
        }
        else if (DateFormatter.containsFormatCode(this.fallbackFormats, formatCode)) {
            format = this.fallbackFormats.formats[formatCode];
        }
        else {
            throw new Error("format '" + formatCode + "' unknown for locale '" + formatLocale + "'.");
        }
        if (isAliasFormat(format)) {
            return this.getFormat(format.alias);
        }
        if (isExtendsDateFormat(format)) {
            format = Object.assign({}, this.getFormat(format.extends), format.by);
        }
        return format;
    };
    DateFormatter.containsFormatCode = function (formatContainer, formatCode) {
        return !!formatContainer && 'formats' in formatContainer && formatCode in formatContainer.formats;
    };
    /**
     * Returns true if the value is less than DateFormatter.UNIX_TIMESTAMP_THRESHOLD, because then it's assumed the value
     * as was passed in as a unix timestamp (seconds) instead of a UTC timestamp (milliseconds).
     *
     * @param value
     * @returns {boolean}
     */
    DateFormatter.isUnixTimestamp = function (value) {
        var numberValue = Number(value);
        return numberValue >= 0 && numberValue < DateFormatter.UNIX_TIMESTAMP_THRESHOLD;
    };
    DateFormatter.LOGGER_NAME = 'DateFormatter';
    DateFormatter.projectFormats = {};
    DateFormatter.projectFallbackFormats = { formats: {} };
    DateFormatter.UNIX_TIMESTAMP_THRESHOLD = 10000000000;
    return DateFormatter;
}());
export { DateFormatter };
//# sourceMappingURL=DateFormatter.js.map